<template>
  <transition
    name="transition-notice"
    appear
    @after-enter="enterHandler"
    @after-leave="leaveHandler"
  >
    <div v-if="show" :key="key" :class="wrapClass" :style="styles">
      <div class="tt-notification-head">
        <icon :name="icon" class="tt-notification-icon" />
      </div>
      <div class="tt-notification-main" @click="clickHandler">
        <h2 v-if="title" class="tt-notification-title">
          {{ title }}
        </h2>
        <p v-if="content" class="tt-notification-content" v-html="content" />
      </div>
      <div class="tt-notification-close" @click="close">
        <icon name="circle-cross" />
      </div>
    </div>
  </transition>
</template>
<script>
import Icon from 'com/Icon'
export default {
  name: 'Notification',
  components: {
    Icon
  },
  props: {
    visible: Boolean, // 是否展示
    icon: {
      type: String,
      default: 'alert2'
    }, // 图标
    title: String, // 标题
    content: String, // 内容
    className: String,
    styles: Object,
    appendToBody: {
      type: Boolean,
      default: true
    },
    destroyOnClose: {
      type: Boolean,
      default: false
    },
    duration: Number,
    closable: {
      type: Boolean,
      default: true
    },
    theme: 'primary' | 'success' | 'warning' | 'error' | 'info'
  },
  data() {
    return {
      show: this.visible,
      key: 0
    }
  },
  watch: {
    visible(val) {
      val ? this.open() : this.close()
    }
  },
  mounted() {
    if (this.appendToBody) {
      document.body.appendChild(this.$el)
    }
  },
  beforeDestroy() {
    this.clearCloseTimer()
  },
  computed: {
    wrapClass() {
      return {
        'tt-notification': true,
        [`tt-notification--${this.placement}`]: this.placement,
        [`tt-notification--${this.theme}`]: this.theme
      }
    }
  },
  methods: {
    close() {
      this.$emit('before-close')
      this.show = false
    },
    open() {
      this.$emit('before-open')
      this.show = true
    },
    clickHandler() {
      this.$emit('click')
    },
    enterHandler() {
      this.$emit('open')
      this.$emit('change', true)
      this.setCloseTimer()
      if (this.appendToBody) {
        document.body.appendChild(this.$el)
      }
    },
    leaveHandler() {
      this.$emit('close')
      this.$emit('change', false)
      this.clearCloseTimer()
      if (this.destroyOnClose) this.key++
    },
    setCloseTimer() {
      if (this.duration) {
        this.timer = setTimeout(() => {
          this.close()
        }, this.duration)
      }
    },
    clearCloseTimer() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    }
  }
}
</script>
<style lang="less" scoped>
.tt-notification {
  position: fixed;
  display: flex;
  align-items: center;
  z-index: 1050;
  user-select: none;
  right: 15px;
  top: 15px;
  width: 344px;
  height: 67px;
  box-shadow: 0 0 13px 0 rgba(0, 0, 0, 0.2), 0 0 3px 0 rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  background: var(--bg-fade);
  backdrop-filter: blur(16px);
  transition: top 200ms ease-in-out;
  &-head {
    width: 47px;
    text-align: center;
    .icon {
      display: block;
      margin: 0 auto;
      color: var(--active-color);
    }
  }
  &-close {
    padding: 15px 15px 15px 30px;
    cursor: pointer;
    .icon {
      display: block;
      width: 17px;
      height: 17px;
      color: var(--light-grey);
      margin: 0 auto;
    }
  }
  &-main {
    flex: 1;
  }
  &-title {
    color: var(--active-color);
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    margin: 0;
    padding: 0;
  }
  &-content {
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-align: justify;
    font-size: 12px;
    line-height: 1.4;
    max-height: 2.8em;
    overflow: hidden;
    margin: 0;
    padding: 0;
  }
}
</style>
<style lang="less">
@import '~styles/transition.less';
.motion(transition-notice, notice, 0.25s, ease-in-out);
@keyframes noticeIn {
  0% {
    opacity: 0;
    transform: translateZ(0) translateX(50%);
  }
  100% {
    opacity: 1;
    transform: translateZ(0) translateX(0);
  }
}

@keyframes noticeOut {
  0% {
    opacity: 1;
    transform: translateZ(0) translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateZ(0) translateY(-10px);
  }
}
</style>
